
import React from 'react';
import SmallMap from './SmallMap';

export default class MapContainer extends React.Component {
  render() {
    return(
      <div className='smallMap'>
        <SmallMap area={this.props.area} lat={this.props.lat} lon={this.props.lon} />
      </div>
    );
  }
}

